import * as yup from 'yup';
import mixed from 'yup';

export const defaultValues = {
  content: '',
  file: null,
};
